export default () => {
    return typeof window !== "undefined";
};
